import { ReactNode } from 'react';

interface Props {
  onClick?: VoidFunction;
  children?: ReactNode;
  hasPermission?: boolean;
}

export default function PurchaseItemSpan(props: Props) {
  return (
    <span
      style={{ width: '100%' }}
      onClick={() => {
        if (!props.hasPermission) return;

        if (props?.onClick) props.onClick();
      }}
      className={props.hasPermission ? 'item-input' : undefined}
    >
      {props.children}
    </span>
  );
}
